"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const PREFIX = 'SskyTableCell';
const classes = {
  root: `${PREFIX}-root`
};
const StyledTableCell = (0, material_1.styled)(material_1.TableCell)(() => ({
  [`& .${classes.root}`]: props => {
    return {
      borderBottom: props.underline ? "1px solid rgba(224, 224, 224, 1)" : "none",
      fontSize: props.fontSize
    };
  }
}));

const SskyTableCell = props => {
  return react_1.default.createElement(StyledTableCell, {
    className: (0, classnames_1.default)("SskyTableCell", props.className),
    classes: {
      root: classes.root
    },
    align: props.numeric ? "right" : props.align,
    colSpan: props.span,
    sortDirection: props.sortDirection,
    "data-testid": props.dataTestId,
    sx: props.padding ? {
      padding: props.padding
    } : {}
  }, props.children);
};

SskyTableCell.defaultProps = {
  align: "inherit",
  fontSize: 12,
  padding: "default",
  span: 1,
  underline: true
};
exports.default = SskyTableCell;